import { faUserSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './style.module.scss';

function NoLawyerFound() {
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.icon}>
                    <FontAwesomeIcon icon={faUserSlash} />
                </div>
                <div className={styles.title}>Aucun Avocat Trouvé</div>
                <div className={styles.content}>
                    Nous n'avons trouvé aucun avocat correspondant à vos
                    critères de recherche.
                </div>
            </div>
            <div className={styles.footer}>
                <p>
                    Essayez d'ajuster vos filtres de recherche ou parcourez
                    notre répertoire pour les avocats disponibles.
                </p>
            </div>
        </div>
    );
}

export default NoLawyerFound;
